import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Input, Select, SideSVG } from "../../../common";
import { ReactComponent as Spinner } from "../../../../assets/icons/spinner.svg";
import { ReactComponent as ArrowRight } from "../../../../assets/icons/arrowright.svg";
import { ReactComponent as ArrowLeft } from "../../../../assets/icons/arrowleft.svg";
import { ReactComponent as LetterSVG } from "../../../../assets/images/signUp/letter.svg";
import Logo from "../../Logo";
import { isPossiblePhoneNumber } from 'react-phone-number-input';
// import { countryCodes } from "../../../common/countryCodes";
import {
  useAuthorizedSignMutation,
  useCreateAuthorizedSignMutation,
  useUpdateAuthorizedSignMutation,
} from "../../../../store/Company/companyApiSlice";
import { geoNames } from "../../../../utils/countriesGeonames";
import { formatDateToISO, handleKeyPress } from "../../../../utils/Helper";
import { setAuthorizedSignatory } from "../../../../store/Company/companySlice";

import { extractCountryCodeAndPhoneCode } from "../../../../utils/countriesState";
import { setClaimAuthSignDetails } from "../../../../store/claim/claimSlice";
import PhoneNumberInput from "../../../common/PhoneNumberInput";

export const AuthorizedSignatory = ({ onNext, onPrev }) => {
  const fullNameRef = useRef();
  const designationRef = useRef();
  const emailAddressRef = useRef();
  // const mobileNumberRef = useRef();
  const [mobile, setMobile] = useState('')
  const [selectedNationality, setSelectedNationality] = useState("");
  const [countryCode, setCountryCode] = useState("+971");
  const [countryCodes, setCountryCodes] = useState(extractCountryCodeAndPhoneCode());
  const [isAcknowledged, setIsAcknowledged] = useState(false)
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");

  const { claimAuthSignDetails } = useSelector((state) => state.claims);
  const { companyData, authorizedSignatory } = useSelector(
    (state) => state.company
  );
  const [authorizedSignCreate, { isLoading }] = useAuthorizedSignMutation();
  const [createAuthorizedSignConnection] = useCreateAuthorizedSignMutation();
  const [updateAuthorizedSign, { isLoading: isUpdating }] =
    useUpdateAuthorizedSignMutation();

  const handleNationalityChange = (e) => {
    const nationality = e.target.value;
    setSelectedNationality(nationality);
  };

  useEffect(() => {
    if (authorizedSignatory || claimAuthSignDetails) {
      fullNameRef.current.value = authorizedSignatory?.name || claimAuthSignDetails?.name;
      designationRef.current.value = authorizedSignatory?.designation || claimAuthSignDetails?.designation;
      emailAddressRef.current.value = authorizedSignatory?.work_email || claimAuthSignDetails?.work_email;
      setMobile(authorizedSignatory?.work_mobile || claimAuthSignDetails?.work_mobile);
      setCountryCode(authorizedSignatory?.work_mobile?.split("|")[0] || claimAuthSignDetails?.work_mobile?.split("|")[0] || "+971");
      setSelectedNationality(authorizedSignatory?.nationality || claimAuthSignDetails?.nationality || "");
    }
  }, [authorizedSignatory, claimAuthSignDetails]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = {};

    if (fullNameRef.current.value.trim() === "") {
      errors.name = "Name can't be blank.";
    }

    if (designationRef.current.value.trim() === "") {
      errors.designation = "Designation can't be blank.";
    }

    if (emailAddressRef.current.value.trim() === "") {
      errors.email = "Email can't be blank.";
    }

    if (mobile?.trim() === "") {
      errors.mobile = "Mobile number can't be blank.";
    }

    if (!isPossiblePhoneNumber(mobile?.toString() ?? "")) {
      errors.mobile = "Enter valid mobile number";
    }

    if (selectedNationality.trim() === "") {
      errors.nationality = "Nationality can't be blank.";
    }

    setErrors(errors);
    if (Object.keys(errors).length === 0) {
      let work_mobile = mobile;
      const jsonData = {
        name: fullNameRef.current.value,
        designation: designationRef.current.value,
        work_email: emailAddressRef.current.value,
        work_mobile: work_mobile,
        nationality: selectedNationality,
        authorized_signatory: `${fullNameRef.current.value} | ${emailAddressRef.current.value} | ${new Date().toLocaleString()}`,
      };
      dispatch(setClaimAuthSignDetails(jsonData))
      // localStorage.setItem("claimAuthSignDetails", jsonData);
      onNext();
    }
  };
  return (
    <section className="relative px-4 sm:px-0 py-20 lg:py-0 overflow-hidden">
      <div className="px-0 mx-auto">
        <div className="mx-auto relative">
          <Logo />
          <div className="flex -mx-4 xl:items-center items-center max-h-screen">
            <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
              <div className="max-w-md py-20 mx-auto ">
                <h3 className="text-f24 sm:text-f30 text-primary font-bold mb-4 text-center">
                  Authorized Signatory
                </h3>
                <p class="text-f16 sm:text-f18 text-secondarytwo mb-4">Add your business’s designated financial and contract signatory
                </p>
                <form>
                  <div className="mb-6">
                    <Input
                      label="Full Name"
                      id="fullName"
                      inputRef={fullNameRef}
                      error={errors.name}
                      placeholder="Enter full name"
                    />
                    <Input
                      label="Designation"
                      id="designation"
                      inputRef={designationRef}
                      error={errors.designation}
                      placeholder="Enter designation"
                    />
                    <Input
                      label="Email Address"
                      id="email"
                      inputRef={emailAddressRef}
                      error={errors.email}
                      placeholder="Enter your email address"
                    />
                    <div className="flex items-start flex-col mb-4 w-full">
                      <label className="text-primary text-f14 font-semibold">
                        Mobile Number
                      </label>
                      <div className="relative w-full">
                        <PhoneNumberInput
                          id="mobile"
                          phone={mobile}
                          border={true}
                          setPhone={setMobile}
                          verifyPhoneNumber={false}
                          classes={'addBackground'}
                          error={""} />
                      </div>
                      {errors.mobile && (
                        <p className="text-red-500 text-sm text-left">
                          {errors.mobile}
                        </p>
                      )}
                    </div>

                    <div className="flex gap-4 w-full">
                      <Select
                        label="Nationality"
                        id="nationality"
                        value={selectedNationality}
                        onChange={handleNationalityChange}
                        error={errors.nationality}
                        placeholder="Select a country"
                      >
                        <option value="">Select a country</option>
                        {geoNames?.map((country) => (
                          <option
                            key={country.countryName}
                            value={country.countryCode}
                          >
                            {country.countryName}
                          </option>
                        ))}
                      </Select>
                    </div>
                    {apiError && (
                      <p className="text-red-500 text-sm text-left">
                        {apiError}
                      </p>
                    )}
                  </div>
                  <div className="flex justify-between gap-2">
                    <button
                      className="inline-flex items-center justify-start mr-2 gap-4 text-primaryText font-bold w-full"

                    >
                      <ArrowLeft onClick={onPrev} />
                      <span className="relative" onClick={onPrev}>Go Back</span>
                    </button>
                    <button
                      className={`relative group w-full py-3 px-5 text-center text-sm font-semibold text-white rounded-md  inline-flex items-center justify-center gap-4 cursor-pointer bg-primary } `}
                      onClick={handleSubmit}
                    >
                      <span className="relative">
                        {isLoading || isUpdating ? (
                          <Spinner />
                        ) : (
                          "Save & Continue"
                        )}
                      </span>
                      <ArrowRight />
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <SideSVG
              SVG={LetterSVG}
              positions="top-1/2 transform -translate-y-1/2 left-[-5%]"
            />
          </div>
        </div>
      </div >
    </section >
  );
};
